<template>
    <div class="mt-16 xl:mt-0">
        <div class="flex justify-between items-center">
            <h1 class="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white">
                الملف الشخصي
            </h1>

            <router-link
                title="تعديل"
                :to="{
                    name: 'editprofile',
                    params: { id: administrator.id },
                }"
                class="w-28 md:w-40 text-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                تعديل
            </router-link>

        </div>

        <div class="py-2 align-middle inline-block min-w-full mt-6">
            <div class="bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 shadow py-6 px-4 sm:p-6 md:flex justify-between items-start">
                <div class="md:w-1/3">
                    <div class="w-20 h-20 sm:w-24 sm:h-24 mx-auto md:mr-0 flex-none lg:w-32 lg:h-32 relative">
                        <img
                            alt="Rubick Tailwind HTML Admin Template"
                            class="rounded-full"
                            src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        />
                        <div
                            class="absolute mb-1 ml-1 flex items-center justify-center bottom-0 left-0 bg-gray-100 dark:bg-slate-900 rounded-full p-2"
                        >
                            <label for="file">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="w-4 h-4 md:w-6 md:h-6 text-slate-500 dark:text-slate-400"
                                >
                                    <path
                                        d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                                    ></path>
                                    <circle cx="12" cy="13" r="4"></circle>
                                </svg>
                                <input
                                    type="file"
                                    name=""
                                    id="file"
                                    class="hidden"
                                />
                            </label>
                        </div>
                    </div>

                    <div class="text-center md:text-right mt-6">
                        <div class="font-medium text-lg">
                            {{ administrator.full_name }}
                        </div>
                        <div class="text-sm mt-1">
                            <span v-for="(key, index) in role" :key="index" class="">
                                {{ key.role_name }} <span v-if="index+1 < role.length ">and</span>

                                <!-- <span v-for="(item, index) in getPrivilegesKey(key)" :key="`${index}-privilege`">
                                    {{ item }}
                                </span> -->
                            </span>
                        </div>
                    </div>
                </div>

                <div class="md:w-1/3 mt-6 md:mt-0 text-slate-500 dark:text-slate-400">
                    <p class="font-medium">معلومات التواصل</p>

                    <div class="flex items-center mt-6">
                        <svg
                            class="w-4 h-4 ml-2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path
                                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                            ></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        {{ administrator.email }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 stroke-current"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M22.6367 17.721V20.721C22.6378 20.9995 22.5807 21.2752 22.4692 21.5303C22.3576 21.7855 22.194 22.0146 21.9887 22.2029C21.7835 22.3911 21.5412 22.5345 21.2774 22.6237C21.0136 22.7129 20.734 22.7461 20.4567 22.721C17.3795 22.3866 14.4237 21.3351 11.8267 19.651C9.41048 18.1157 7.36199 16.0672 5.82665 13.651C4.13663 11.0422 3.08489 8.07199 2.75665 4.981C2.73166 4.70447 2.76453 4.42576 2.85315 4.16262C2.94178 3.89949 3.08422 3.65769 3.27142 3.45262C3.45861 3.24755 3.68646 3.08371 3.94044 2.97152C4.19443 2.85933 4.46899 2.80126 4.74665 2.801H7.74665C8.23196 2.79622 8.70244 2.96808 9.07041 3.28453C9.43838 3.60099 9.67873 4.04045 9.74665 4.521C9.87327 5.48107 10.1081 6.42373 10.4467 7.331C10.5812 7.68892 10.6103 8.07791 10.5306 8.45188C10.4508 8.82585 10.2655 9.16911 9.99665 9.441L8.72665 10.711C10.1502 13.2145 12.2231 15.2874 14.7267 16.711L15.9967 15.441C16.2685 15.1721 16.6118 14.9868 16.9858 14.9071C17.3597 14.8273 17.7487 14.8565 18.1067 14.991C19.0139 15.3296 19.9566 15.5644 20.9167 15.691C21.4024 15.7595 21.8461 16.0042 22.1632 16.3785C22.4803 16.7528 22.6488 17.2306 22.6367 17.721Z"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        {{ administrator.phone_number }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 stroke-current"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_116_4)">
                                <path
                                    d="M21.6367 10.801C21.6367 17.801 12.6367 23.801 12.6367 23.801C12.6367 23.801 3.63672 17.801 3.63672 10.801C3.63672 8.41408 4.58493 6.12489 6.27276 4.43706C7.96058 2.74924 10.2498 1.80103 12.6367 1.80103C15.0237 1.80103 17.3129 2.74924 19.0007 4.43706C20.6885 6.12489 21.6367 8.41408 21.6367 10.801Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M12.6367 13.801C14.2936 13.801 15.6367 12.4579 15.6367 10.801C15.6367 9.14417 14.2936 7.80103 12.6367 7.80103C10.9799 7.80103 9.63672 9.14417 9.63672 10.801C9.63672 12.4579 10.9799 13.801 12.6367 13.801Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_116_4">
                                    <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.636719 0.801025)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>

                        {{ administrator.address }}
                    </div>
                </div>

                <div class="md:w-1/3 mt-6 md:mt-0 text-slate-500 dark:text-slate-400">
                    <p class="font-medium">معلومات عامة</p>

                    <div class="flex items-center mt-6">
                        <svg
                            class="w-4 h-4 ml-2 stroke-current"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M20 12V22H4V12"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M22 7H2V12H22V7Z"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 22V7"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        {{ administrator.birth_date }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 fill-current"
                            width="135"
                            height="135"
                            viewBox="0 0 135 135"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M95.9434 59.99C96.3423 59.0438 97.0115 58.2363 97.867 57.6685C98.7226 57.1007 99.7266 56.7979 100.753 56.7979C101.78 56.7979 102.784 57.1007 103.64 57.6685C104.495 58.2363 105.165 59.0438 105.563 59.99L133.963 127.11C134.502 128.387 134.512 129.826 133.991 131.11C133.47 132.395 132.46 133.42 131.183 133.96C130.552 134.235 129.872 134.377 129.183 134.38H72.3834C71.5216 134.378 70.6735 134.164 69.9146 133.755C69.1557 133.347 68.5095 132.757 68.0335 132.039C67.5575 131.32 67.2664 130.495 67.1861 129.637C67.1059 128.779 67.2389 127.914 67.5734 127.12L95.9434 59.99ZM62.0334 56.8C62.8953 56.8016 63.7434 57.0163 64.5023 57.4247C65.2612 57.8332 65.9074 58.4229 66.3834 59.1414C66.8594 59.8599 67.1505 60.6848 67.2308 61.543C67.311 62.4011 67.178 63.2657 66.8434 64.06L38.4434 131.19C38.0445 132.136 37.3754 132.944 36.5199 133.511C35.6643 134.079 34.6603 134.382 33.6334 134.382C32.6066 134.382 31.6026 134.079 30.747 133.511C29.8914 132.944 29.2223 132.136 28.8234 131.19L0.423431 64.06C0.151795 63.4273 0.00799839 62.7472 0.000324287 62.0587C-0.00734982 61.3703 0.121249 60.6871 0.378716 60.0485C0.636182 59.41 1.01743 58.8287 1.5005 58.3381C1.98358 57.8475 2.55893 57.4573 3.19343 57.19C3.82459 56.9154 4.50514 56.7725 5.19343 56.77L62.0334 56.8ZM100.753 75.43L80.2434 123.93H121.243L100.733 75.43H100.753ZM54.1934 67.25H13.1934L33.7134 115.75L54.1934 67.25ZM33.6334 2.14797e-06C38.2417 2.14797e-06 42.7466 1.36652 46.5782 3.92676C50.4099 6.487 53.3963 10.126 55.1598 14.3835C56.9233 18.641 57.3848 23.3258 56.4857 27.8456C55.5867 32.3654 53.3676 36.517 50.109 39.7756C46.8505 43.0342 42.6988 45.2533 38.179 46.1523C33.6593 47.0513 28.9744 46.5899 24.7169 44.8264C20.4594 43.0629 16.8204 40.0765 14.2602 36.2448C11.7 32.4131 10.3334 27.9083 10.3334 23.3C10.3321 20.2398 10.9339 17.2094 12.1044 14.3819C13.2748 11.5544 14.991 8.98535 17.1549 6.82148C19.3188 4.65762 21.8879 2.9414 24.7154 1.77093C27.5428 0.600461 30.5733 -0.00131208 33.6334 2.14797e-06ZM100.753 2.14797e-06C106.933 2.14797e-06 112.859 2.45481 117.229 6.82441C121.599 11.194 124.053 17.1205 124.053 23.3C124.053 27.9083 122.687 32.4131 120.127 36.2448C117.566 40.0765 113.927 43.0629 109.67 44.8264C105.412 46.5899 100.728 47.0513 96.2078 46.1523C91.6881 45.2533 87.5364 43.0342 84.2778 39.7756C81.0193 36.517 78.8002 32.3654 77.9011 27.8456C77.0021 23.3258 77.4635 18.641 79.227 14.3835C80.9906 10.126 83.977 6.487 87.8086 3.92676C91.6403 1.36652 96.1451 2.14797e-06 100.753 2.14797e-06ZM33.6334 10.45C31.9459 10.45 30.275 10.7824 28.716 11.4281C27.1569 12.0739 25.7403 13.0204 24.5471 14.2137C23.3539 15.4069 22.4074 16.8235 21.7616 18.3825C21.1158 19.9416 20.7834 21.6125 20.7834 23.3C20.7834 24.9875 21.1158 26.6584 21.7616 28.2175C22.4074 29.7765 23.3539 31.1931 24.5471 32.3863C25.7403 33.5796 27.1569 34.5261 28.716 35.1719C30.275 35.8176 31.9459 36.15 33.6334 36.15V36.15C37.0415 36.15 40.3099 34.7962 42.7198 32.3863C45.1296 29.9765 46.4834 26.708 46.4834 23.3C46.4834 19.892 45.1296 16.6235 42.7198 14.2137C40.3099 11.8038 37.0415 10.45 33.6334 10.45V10.45ZM100.753 10.45C97.3454 10.45 94.077 11.8038 91.6671 14.2137C89.2573 16.6235 87.9034 19.892 87.9034 23.3C87.9034 26.708 89.2573 29.9765 91.6671 32.3863C94.077 34.7962 97.3454 36.15 100.753 36.15C104.161 36.15 107.43 34.7962 109.84 32.3863C112.25 29.9765 113.603 26.708 113.603 23.3C113.603 19.892 112.25 16.6235 109.84 14.2137C107.43 11.8038 104.161 10.45 100.753 10.45Z"
                            />
                        </svg>

                        {{ administrator.gender }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 stroke-current"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M1 10H23"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        {{ administrator.nid }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 stroke-2 fill-current"
                            width="321"
                            height="401"
                            viewBox="0 0 321 401"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M302.665 95.5109C281.841 50.9909 244.929 17.2389 198.729 0.486907C194.585 -1.03309 189.985 1.12691 188.481 5.27891L174.721 43.2069C162.113 39.4389 149.137 37.4229 136.001 37.4229C78.9772 37.4229 27.5932 73.4549 8.14517 127.087C-16.5028 195.039 16.6732 269.967 82.2412 298.199L68.4652 336.183C67.7452 338.175 67.8412 340.375 68.7372 342.303C69.6332 344.231 71.2572 345.711 73.2572 346.439C90.8492 352.815 108.777 356.175 126.561 357.071V384.007H70.5612C66.1452 384.007 62.5612 387.583 62.5612 392.007C62.5612 396.431 66.1452 400.007 70.5612 400.007H198.561C202.985 400.007 206.561 396.431 206.561 392.007C206.561 387.583 202.985 384.007 198.561 384.007H142.561V357.207C215.265 354.511 282.681 308.695 308.977 236.199C325.721 189.999 323.481 140.031 302.665 95.5109V95.5109ZM23.1772 132.543C40.3452 85.2229 85.6732 53.4229 135.993 53.4229C149.921 53.4229 163.681 55.8549 176.905 60.6469C207.041 71.5749 231.105 93.5829 244.689 122.623C258.273 151.663 259.737 184.247 248.801 214.375C231.641 261.703 186.305 293.503 135.993 293.503C122.065 293.503 108.297 291.063 95.0732 286.271C32.8732 263.703 0.617168 194.743 23.1772 132.543V132.543ZM293.921 230.751C263.257 315.303 171.337 360.343 86.2892 333.943L97.2492 303.719C109.873 307.487 122.849 309.503 135.985 309.503C193.001 309.503 244.385 273.463 263.841 219.831C276.225 185.687 274.577 148.759 259.185 115.847C244.929 85.3749 220.393 61.8709 189.745 48.7029L200.721 18.4309C282.905 52.6869 324.593 146.175 293.921 230.751V230.751Z"
                            />
                        </svg>

                        {{ administrator.country }}
                    </div>

                    <div class="flex items-center mt-4">
                        <svg
                            class="w-4 h-4 ml-2 stroke-current"
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                        >
                            <path
                                style="
                                    line-height: normal;
                                    text-indent: 0;
                                    text-align: start;
                                    text-decoration-line: none;
                                    text-decoration-style: solid;
                                    text-decoration-color: #000;
                                    text-transform: none;
                                    block-progression: tb;
                                    white-space: normal;
                                    isolation: auto;
                                    mix-blend-mode: normal;
                                    solid-color: #000;
                                    solid-opacity: 1;
                                "
                                fill-rule="evenodd"
                                d="M 19 4 L 19 12.955078 L 15 12.955078 L 15 8.9550781 L 13 8.9550781 L 13 7.9550781 L 9 7.9550781 L 9 8.9550781 L 7 8.9550781 L 7 11.955078 L 4.0996094 11.955078 L 4.0996094 5.9550781 L 0 5.9550781 L 0 29.955078 L 1 29.955078 L 1 20.455078 L 1.9492188 20.455078 L 1.9492188 22.455078 L 5 22.455078 L 5 30 L 6 30 L 6 17.955078 L 8.4121094 17.955078 L 8.4121094 15.955078 L 10.6875 15.955078 L 10.6875 17.955078 L 13 17.955078 L 13 16.955078 L 11.6875 16.955078 L 11.6875 14.955078 L 7.4121094 14.955078 L 7.4121094 16.955078 L 5 16.955078 L 5 21.455078 L 2.9492188 21.455078 L 2.9492188 19.455078 L 1 19.455078 L 1 6.9550781 L 3.0996094 6.9550781 L 3.0996094 12.955078 L 8 12.955078 L 8 9.9550781 L 10 9.9550781 L 10 8.9550781 L 12 8.9550781 L 12 9.9550781 L 14 9.9550781 L 14 13.955078 L 20 13.955078 L 20 5 L 24 5 L 24 14.955078 L 28 14.955078 L 28 7.9550781 L 31 7.9550781 L 31 18.955078 L 28.5 18.955078 L 28.5 16.955078 L 24 16.955078 L 24 17.955078 L 27.5 17.955078 L 27.5 19.955078 L 31 19.955078 L 31 29.955078 L 32 29.955078 L 32 19.955078 L 32 18.955078 L 32 6.9550781 L 27 6.9550781 L 27 13.955078 L 25 13.955078 L 25 4 L 19 4 z M 17.023438 14.953125 A 0.50004991 0.50004991 0 0 0 16.972656 14.955078 A 0.50004991 0.50004991 0 0 0 16.660156 15.085938 L 10.162109 21.085938 A 0.50004991 0.50004991 0 0 0 10.5 21.955078 L 11 21.955078 L 11 29.453125 A 0.50005 0.50005 0 0 0 11.5 29.953125 L 22.5 29.953125 A 0.50005 0.50005 0 0 0 23 29.453125 L 23 21.955078 L 23.5 21.955078 A 0.50004991 0.50004991 0 0 0 23.839844 21.085938 L 23 20.310547 L 23 17.460938 A 0.50005 0.50005 0 0 0 22.492188 16.955078 A 0.50005 0.50005 0 0 0 22 17.460938 L 22 19.386719 L 17.339844 15.085938 A 0.50004991 0.50004991 0 0 0 17.023438 14.953125 z M 17 16.136719 L 22.220703 20.955078 L 11.779297 20.955078 L 17 16.136719 z M 12 22.169922 L 22 22.169922 L 22 28.953125 L 19 28.953125 L 19 25.453125 A 0.50004988 0.50004988 0 0 0 18.5 24.953125 L 15.5 24.953125 A 0.50004988 0.50004988 0 0 0 15 25.453125 L 15 28.953125 L 12 28.953125 L 12 22.169922 z M 16 25.953125 L 18 25.953125 L 18 28.953125 L 16 28.953125 L 16 25.953125 z "
                                enable-background="accumulate"
                                font-family="sans-serif"
                                font-weight="400"
                                overflow="visible"
                            />
                        </svg>

                        {{ administrator.city }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    created() {},
    mounted(){},
    
    data() {
        return {
            administrator: this.$store.state.auth.administrator,
            role: this.$store.state.auth.role,
        };
    },

    computed: {
    },
    
    methods: {
        getPrivilegesKey(key) {
            return Object.keys(key);
        },
    },
};
</script>
